import {ReactComponent as StarIcon} from './../../../asset/icons/starIconYellow.svg';
import {ReactComponent as SellerIcon} from './../../../asset/icons/seller.svg';
import {ReactComponent as PinIcon} from './../../../asset/icons/pin.svg';
import {ReactComponent as AddSellerIcon} from './../../../asset/icons/add-seller.svg';

import {ReactComponent as Bookmark} from "../../../asset/icons/bookmark_white.svg";
import {ReactComponent as Share} from "../../../asset/icons/share_white.svg";
import {ReactComponent as TwoColorUser} from "../../../asset/icons/two-color-user.svg";


import defaultImage from './../../../asset/image/ex_img_3.png';
import logo from './../../../asset/image/just-logo.png';
import { Navigate, useNavigate } from 'react-router-dom';

export default function ItemCart(
    {
        link,
        score,
        description,
        fullDescritpion,
        name,
        photo,
        priceMin,
        priceMax,
        salersCount
    }
){
    const history = useNavigate();
    return (
        <div className="item-cart" onClick={_=>{if(link) history("/dashboard/food/form/new/" + link)}}>
            <div className="image-section">
                <div>
                    <button><Bookmark /></button>
                    <button><Share /></button>
                    <button><TwoColorUser /></button>
                </div>
                <img src={photo || defaultImage} alt="image" />
                <div>
                    <div>
                        <div className='company-logo'>
                            <img src={logo} alt="company logo" />
                        </div>
                    </div>
                    <div>
                        <div className='number-of-sellers'>
                            <TwoColorUser />
                            تعداد فروشندگان: {salersCount || '0'}
                        </div>
                    </div>
                </div>
            </div>
            <h3>{name}</h3>
            <p className={fullDescritpion ? 'full-desc' : 'short-desc'}>{description}</p>
            <div className='star-con'>
                <StarIcon />
                <span><b>{Math.round(score)}/</b>{Math.round(score % 1 * 10)}</span>
            </div>
            <div>
                بازه قیمتی
            </div>
            {
                priceMin && priceMax
                ?
                    <div className='price-range'>
                        <div>{priceMin ? (priceMin * 1).toLocaleString() : '-'} <span>تومان</span></div>
                        <div>{priceMin ? (priceMax * 1).toLocaleString() : '-'} <span>تومان</span></div>
                    </div>
                :
                <div className='price-range'>مشخص نشده</div>
            }
            <div className='cart-footer-section'>
                <div>
                    <button><SellerIcon /></button> تعداد فروشندگان: {salersCount || '0'}
                </div>
                <div>
                    <button><PinIcon /></button>
                    <button><AddSellerIcon /></button>
                </div>
            </div>
        </div>
    )
}
